export default {
	state: {
		remainingFood: 0,
		hasBorrowedFood: false,
		isBorrowingFood: false,
		showFoodMessage: false,
	},
	actions: {
		feed(context, payload) {
			context.commit("decrementFood", payload);
		},
		borrowFood(context) {
			context.commit("incrementFood", { amount: context.getters.borrowFoodAmount });
			context.commit("borrowFood");
		},
		cyclicFoodIncrease(context) {
			let amount = context.getters.cyclicFoodAmount;

			if (context.state.isBorrowingFood) {
				amount = context.getters.unBorrowedFoodAmount;
			}

			context.commit("incrementFood", { amount });
			context.commit("resetFoodBorrowing");
		},
	},
	mutations: {
		incrementFood(state, payload) {
			state.remainingFood += payload.amount;
		},
		decrementFood(state, payload) {
			state.remainingFood -= payload.amount;
		},
		borrowFood(state) {
			state.isBorrowingFood = true;
			state.hasBorrowedFood = true;
		},
		resetFoodBorrowing(state) {
			state.isBorrowingFood = false;
		},
		activateFoodMessage(state) {
			state.showFoodMessage = true;
		},
		deactivateFoodMessage(state) {
			state.showFoodMessage = false;
		},
	},
	getters: {
		cyclicFoodAmount(state, getters, rootState, rootGetters) {
			let amount = 0;

			if (rootState.cats.selectionKey === "mixed_litter") {
				amount = rootState.config.mixed_litter.scoop_replenish_count;
			} else if (rootGetters.hasSelectedCats) {
				amount = rootGetters.selectedCatBreed().scoop_replenish_count;
			}

			return amount;
		},
		borrowFoodBaseAmount(state, getters) {
			return getters.cyclicFoodAmount / 2;
		},
		borrowFoodAmount(state, getters) {
			return Math.floor(getters.borrowFoodBaseAmount);
		},
		unBorrowedFoodAmount(state, getters) {
			return Math.ceil(getters.borrowFoodBaseAmount);
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/food.js